import ThanksModal from './thanks-modal';
export default ThanksModal;